.g2{gap:0.25rem;}